import * as React from "react";

import { getAccessToken, setSelecterDisplay } from "../../Common";
import { LOCAL_CONSTANT } from "../../Const";

import { Box, Typography } from "@mui/material";

const listHeaderStyle = {
    width: "150px",
    height: "50px",
    padding: "12px 0",
    border: "1px solid black",
    backgroundColor: "#D9D9D9",
};

const listStyle = {
    width: "150px",
    height: "50px",
    padding: "12px 0",
    border: "1px solid black",
};

interface resultProps {
    props: {
        planAreaId: string | null;
        branch: string | null;
        locationConflictMarketCut: any;
        locationConflict: any;
        locationSMDS: any;
        marketCut: any;
        codeMaster: any;
    };
}

const ApprovalMarketCutDetail: React.FC<resultProps> = ({ props }) => {
    const [approvalMarketCutMgr, setApprovalMarketCutMgr] = React.useState<boolean>(false);
    const [marketCutApprovalResearchMgrStamp, setMarketCutApprovalResearchMgrStamp] = React.useState<string>("");
    const [marketCutApprovalResearchGmStamp, setMarketCutApprovalResearchGmStamp] = React.useState<string>("");
    const [marketCutApprovalMgrStamp, setMarketCutApprovalMgrStamp] = React.useState<string>("");
    const [marketCutApprovalGmStamp, setMarketCutApprovalGmStamp] = React.useState<string>("");

    React.useEffect(() => {
        const bucket_path = process.env.REACT_APP_GOOGLE_STORAGE + "/" + process.env.REACT_APP_FIREBASE_STORAGE_BUCKET + "/" + props.planAreaId + "/" + props.branch;
        const access_token = getAccessToken();
        if (props.locationConflictMarketCut) {
            // 商圏カット根拠
            if (props.locationConflictMarketCut.approval_research_mgr_flag === "1") {
                setApprovalMarketCutMgr(true);
            }
            // 印影画像
            if (props.locationConflictMarketCut.approval_research_mgr_stamp) {
                setMarketCutApprovalResearchMgrStamp(bucket_path + props.locationConflictMarketCut.approval_research_mgr_stamp + access_token);
            }
            if (props.locationConflictMarketCut.approval_research_gm_stamp) {
                setMarketCutApprovalResearchGmStamp(bucket_path + props.locationConflictMarketCut.approval_research_gm_stamp + access_token);
            }
            if (props.locationConflictMarketCut.approval_mgr_stamp) {
                setMarketCutApprovalMgrStamp(bucket_path + props.locationConflictMarketCut.approval_mgr_stamp + access_token);
            }
            if (props.locationConflictMarketCut.approval_gm_stamp) {
                setMarketCutApprovalGmStamp(bucket_path + props.locationConflictMarketCut.approval_gm_stamp + access_token);
            }
        }
    }, [props.locationConflictMarketCut]);

    const displayLiquorTobacco = (liquor: string, tobacco: string) => {
        return setSelecterDisplay(props.codeMaster.marubatu, liquor) + "/" + setSelecterDisplay(props.codeMaster.marubatu, tobacco);
    };

    const displayCode = (label: string, val: string) => {
        let result = "";
        props.codeMaster[label].map((row: any) => {
            if (row.code_value === val) {
                result = row["code_display"];
            }
        });
        return result;
    };

    return (
        <Box sx={{ display: props.locationConflictMarketCut.cut_market === "1" ? "block" : "none" }}>
            <Box sx={{ padding: "20px 0" }}>
                <h3>{LOCAL_CONSTANT.LABEL.BASIS_FOR_TRADE_AREA_CUT}</h3>
            </Box>
            <Box>
                <Box sx={{ display: "flex" }}>
                    <Box sx={{ width: "120px", border: "1px solid #000", textAlign: "center" }}>リサーチ Mgr</Box>
                    <Box sx={{ width: "120px", border: "1px solid #000", textAlign: "center", display: approvalMarketCutMgr ? "block" : "none" }}>リサーチ GM</Box>
                    <Box sx={{ width: "120px", border: "1px solid #000", textAlign: "center" }}>リクルート Mgr</Box>
                    <Box sx={{ width: "120px", border: "1px solid #000", textAlign: "center" }}>リクルート GM</Box>
                </Box>
                <Box sx={{ display: "flex" }}>
                    <Box sx={{ width: "120px", height: "92px", border: "1px solid #000", textAlign: "center" }}>
                        <img src={marketCutApprovalResearchMgrStamp}></img>
                    </Box>
                    <Box sx={{ width: "120px", height: "92px", border: "1px solid #000", textAlign: "center", display: approvalMarketCutMgr ? "block" : "none" }}>
                        <img src={marketCutApprovalResearchGmStamp}></img>
                    </Box>
                    <Box sx={{ width: "120px", height: "92px", border: "1px solid #000", textAlign: "center" }}>
                        <img src={marketCutApprovalMgrStamp}></img>
                    </Box>
                    <Box sx={{ width: "120px", height: "92px", border: "1px solid #000", textAlign: "center" }}>
                        <img src={marketCutApprovalGmStamp}></img>
                    </Box>
                </Box>
            </Box>
            <Typography sx={{ padding: "20px 0" }}>実質商圏（商圏カット）</Typography>
            <Box sx={{ display: "flex" }}>
                <Typography sx={{ width: "100px" }}>注意</Typography>
                <Typography>間違いなく来店が見込めないという根拠に基づき、カットを判断して下さい。</Typography>
            </Box>
            <Box sx={{ display: "flex" }}>
                <Typography sx={{ width: "100px" }}>定義</Typography>
                <Box>
                    <Typography>・自店の来店メインターゲットは歩行者である</Typography>
                    <Typography>・徒歩５分商圏内で線路・河川・総４車線以上の大規模道路・駅・大型施設等のバリア要素により、バリアの反対側から徒歩での来店が見込めない範囲</Typography>
                </Box>
            </Box>
            <Box sx={{ display: "flex" }}>
                <Typography sx={{ width: "100px" }}>ルール</Typography>
                <Typography>削除となる基礎競合（ＣＶＳ・ＳＭ等全ての競合店）はバリア要素の反対側にある全てが対象（但し導線競合は対象外）</Typography>
            </Box>
            <Box>
                <Typography sx={{ padding: "20px 0" }}>実質世帯数、従業員数</Typography>
                <Box sx={{ width: "500px", textAlign: "center" }}>
                    <Box sx={{ display: "flex" }}>
                        <Typography sx={{ width: "100px", padding: "12px 0", border: "1px solid black", backgroundColor: "#D9D9D9", color: "#D9D9D9" }}>tab</Typography>
                        <Typography sx={{ width: "200px", padding: "12px 0", border: "1px solid black", backgroundColor: "#D9D9D9" }}>世帯数</Typography>
                        <Typography sx={{ width: "200px", padding: "12px 0", border: "1px solid black", backgroundColor: "#D9D9D9" }}>従業員数</Typography>
                    </Box>
                    <Box sx={{ display: "flex" }}>
                        <Typography sx={{ width: "100px", padding: "12px 0", border: "1px solid black" }}>徒歩5分商圏</Typography>
                        <Typography sx={{ width: "200px", padding: "12px 0", border: "1px solid black", backgroundColor: "rgba(0, 0, 0, 0.06)" }}>{props.marketCut.households}</Typography>
                        <Typography sx={{ width: "200px", padding: "12px 0", border: "1px solid black", backgroundColor: "rgba(0, 0, 0, 0.06)" }}>{props.marketCut.employees}</Typography>
                    </Box>
                    <Box sx={{ display: "flex" }}>
                        <Typography sx={{ width: "100px", padding: "12px 0", border: "1px solid black" }}>削除商圏</Typography>
                        <Typography sx={{ width: "200px", padding: "12px 0", border: "1px solid black", backgroundColor: "rgba(0, 0, 0, 0.06)" }}>{props.marketCut.delete_households}</Typography>
                        <Typography sx={{ width: "200px", padding: "12px 0", border: "1px solid black", backgroundColor: "rgba(0, 0, 0, 0.06)" }}>{props.marketCut.delete_employees}</Typography>
                    </Box>
                    <Box sx={{ display: "flex" }}>
                        <Typography sx={{ width: "100px", padding: "12px 0", border: "1px solid black" }}>実質商圏</Typography>
                        <Typography sx={{ width: "200px", padding: "12px 0", border: "1px solid black", backgroundColor: "rgba(0, 0, 0, 0.06)" }}>{props.marketCut.substance_households}</Typography>
                        <Typography sx={{ width: "200px", padding: "12px 0", border: "1px solid black", backgroundColor: "rgba(0, 0, 0, 0.06)" }}>{props.marketCut.substance_employees}</Typography>
                    </Box>
                </Box>
            </Box>
            <Box>
                <Typography sx={{ padding: "20px 0" }}>{LOCAL_CONSTANT.LABEL.ESSENTIALLY_COMPETING_STORE}</Typography>
                <Box sx={{ width: "1050px", textAlign: "center" }}>
                    <Box sx={{ width: "100%", textAlign: "center" }}>
                        <Box sx={{ display: "flex" }}>
                            <Typography sx={listHeaderStyle}>{LOCAL_CONSTANT.LABEL.CHAIN_NAME}</Typography>
                            <Typography sx={listHeaderStyle}>{LOCAL_CONSTANT.LABEL.STORE_NAME}</Typography>
                            <Typography sx={listHeaderStyle}>{LOCAL_CONSTANT.LABEL.LIQUOR + "・" + LOCAL_CONSTANT.LABEL.TOBACCO}</Typography>
                            <Typography sx={listHeaderStyle}>{LOCAL_CONSTANT.LABEL.BUSINESS_HOURS}</Typography>
                            <Typography sx={listHeaderStyle}>{LOCAL_CONSTANT.LABEL.DIRECT_DISTANCE + "（" + LOCAL_CONSTANT.LABEL.METER + "）"}</Typography>
                            <Typography sx={listHeaderStyle}>{LOCAL_CONSTANT.LABEL.SALES_FLOOR_AREA + "（" + LOCAL_CONSTANT.LABEL.SQUARE_METER + "）"}</Typography>
                            <Typography sx={listHeaderStyle}>{LOCAL_CONSTANT.LABEL.PARKING_AREA + "（" + LOCAL_CONSTANT.LABEL.SQUARE_METER + "）"}</Typography>
                        </Box>
                    </Box>
                    <Box sx={{ width: "100%" }}>
                        {props.locationConflict?.map((row: any) => (
                            <Box key={"lc-" + row.plan_area_id + "-" + row.branch + "-" + row.conflict_type + "-" + row.conflict_sequence}>
                                <Box sx={{ display: "flex" }}>
                                    <Typography sx={listStyle}>{row.bland_name}</Typography>
                                    <Typography sx={listStyle}>{row.tenpo_name}</Typography>
                                    <Typography sx={listStyle}>{displayLiquorTobacco(row.handle_category_liquor, row.handle_category_tobacco)}</Typography>
                                    <Typography sx={listStyle}>{displayCode("business_hours", row.business_hours)}</Typography>
                                    <Typography sx={listStyle}>{Math.round(row.direct_distance * 100) / 100}</Typography>
                                    <Typography sx={listStyle}>{row.sales_floor_area_size}</Typography>
                                    <Typography sx={listStyle}>{row.parking_area_size}</Typography>
                                </Box>
                            </Box>
                        ))}
                        {props.locationSMDS?.map((row: any) => (
                            <Box key={"SMDS-" + row.plan_area_id + "-" + row.branch + row.conflict_type + "-" + row.conflict_sequence}>
                                <Box sx={{ display: "flex" }}>
                                    <Typography sx={listStyle}>{row.bland_name}</Typography>
                                    <Typography sx={listStyle}>{row.tenpo_name}</Typography>
                                    <Typography sx={listStyle}>{displayLiquorTobacco(row.handle_category_liquor, row.handle_category_tobacco)}</Typography>
                                    <Typography sx={listStyle}>{displayCode("business_hours", row.business_hours)}</Typography>
                                    <Typography sx={listStyle}>{Math.round(row.direct_distance * 100) / 100}</Typography>
                                    <Typography sx={listStyle}>{row.sales_floor_area_size}</Typography>
                                    <Typography sx={listStyle}>{row.parking_area_size}</Typography>
                                </Box>
                            </Box>
                        ))}
                    </Box>
                </Box>
            </Box>
            <Box sx={{ padding: "20px 0" }}>
                {/* <Box sx={{ display: 'flex' }}>
                    <Box sx={{ width: '560px', minWidth: '560px', maxWidth: '560px', height: '360px', margin: "20px" }}>
                        <img style={{ width: "100%" }} src={marketCutImage001}></img>
                    </Box>
                    <Box sx={{ width: '560px', minWidth: '560px', maxWidth: '560px', height: '360px', margin: "20px" }}>
                        <img style={{ width: "100%" }} src={marketCutImage002}></img>
                    </Box>
                </Box> */}
            </Box>
        </Box>
    );
};

export default ApprovalMarketCutDetail;
